export const dev = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'vfCzqDw7R6Dkr96HicwqFie5YYceOLGe',
        audience: 'https://crew-time/api',
    }
}

export const prod = {
    auth0: {
        domain: 'dev-crew-time.eu.auth0.com',
        clientId: 'vfCzqDw7R6Dkr96HicwqFie5YYceOLGe',
        audience: 'https://crew-time/api',
    }
}